module.exports = __webpack_public_path__ + "media/images/emblems/GW-BE-Plateau-de-Diesse-53830d7ceee77bd72679e5d66f23cca7.png";